{
  "dashboard": {
    "place": {
      "inShift": "Now at {{clinic}} · until {{end}}",
      "between": "Next shift: {{clinic}} · {{start}}",
      "beforeFirst": "Today: {{clinic}} from {{start}}",
      "done": "Today's shift is over · {{clinic}}",
      "overlap": "Scheduled at {{count}} practices at once",
      "noShiftToday": "No hours registered for today",
      "noShiftDay": "No hours registered for this day",
      "noShiftHint": "Your practice registers your hours",
      "otherDay": "{{weekday}}: {{clinic}} {{hours}}",
      "more": "and {{count}} more",
      "aria": "Where your schedule puts you"
    },
    "stats": {
      "total": "booked",
      "waiting": "waiting",
      "completed": "seen",
      "cancelled": "cancelled",
      "aria": "{{total}} booked, {{waiting}} waiting, {{completed}} seen, {{cancelled}} cancelled",
      "share": "Share: {{amount}}",
      "shareNoFigure": "Share"
    },
    "week": {
      "title": "Pick a day",
      "thisWeek": "This week",
      "nextWeek": "Next week",
      "prevWeek": "Last week",
      "range": "{{from}} – {{to}}",
      "fullCalendar": "Full calendar",
      "backToWeek": "Back to the week",
      "countAria": "{{count}} appointments"
    },
    "clinic": {
      "auto": "Automatic — follow my schedule",
      "autoSub": "The practice your schedule names for this day",
      "autoBadge": "Auto"
    },
    "book": {
      "open": "New appointment",
      "title": "Book an appointment",
      "clinic": "Clinic",
      "patient": "Patient",
      "searchLabel": "Find a patient",
      "searchPlaceholder": "Name, phone or national ID",
      "searchHint": "Type at least two characters.",
      "noMatch": "No patient on your list matches this.",
      "truncated": "Showing the first {{count}} results; narrow the search.",
      "newPatient": "New patient",
      "pickExisting": "Choose from patients",
      "change": "Change",
      "name": "Full name",
      "phone": "Mobile number",
      "nationalId": "National ID (optional)",
      "when": "Date and time",
      "duration": "Length",
      "minutes": "{{count}} min",
      "note": "Note (optional)",
      "submit": "Book appointment",
      "submitRequest": "Send for clinic approval",
      "readOnlyTitle": "Read-only — the clinic’s subscription has ended",
      "readOnly": "This clinic’s subscription has ended and its panel is read-only; no appointment can be booked or moved there until the clinic renews. Your other clinics are not affected.",
      "readOnlyOption": "{{name}} (read-only)",
      "needsApprovalTitle": "Needs clinic approval",
      "needsApproval": "Appointments you book at this clinic are final only once reception confirms them; until then they stay “awaiting clinic confirmation”.",
      "booked": "Appointment booked.",
      "requested": "Appointment sent to the clinic for approval.",
      "loadFailed": "Could not load your clinics.",
      "noClinic": "You cannot book at any clinic right now.",
      "searchFailed": "Patient search failed.",
      "modeFirstDay": "First slot this day",
      "modeFirstToday": "First slot today",
      "modeManual": "Pick a time",
      "showTimeOptions": "Change the day or how the time is picked",
      "hideTimeOptions": "Hide time options",
      "noneLeftToday": "There are no free slots left today.",
      "finding": "Finding the next free slot…",
      "bookThisOne": "Book it",
      "firstFree": "First free slot",
      "exactAtBooking": "The exact time is settled when you book.",
      "firstSlotFailed": "The next free slot could not be found. You can pick a time yourself.",
      "lessOptions": "Hide more options",
      "typeInPerson": "In person",
      "typeOnline": "Remote",
      "submitFirst": "Book the first appointment",
      "walkIn": "Walk-in, right now",
      "walkInOff": "The patient is here now; add them to today’s queue without a time.",
      "walkInOn": "Booked without a time; the patient joins today’s queue now.",
      "walkInOnShort": "No time; joins today’s queue.",
      "walkInLead": "No free slots left today; add the patient to today’s queue now, without a time.",
      "walkInLeadShort": "No time, today’s queue.",
      "walkInNoGrant": "At this clinic your bookings wait for reception; a patient who is already here is added by the clinic’s reception.",
      "walkInNoGrantShort": "At this clinic only reception can add a walk-in.",
      "alreadyOpen": {
        "scheduled": "This patient already has another appointment today that has not arrived yet.",
        "arrived": "This patient is already in today's queue — is a second appointment needed?",
        "in_visit": "This patient is in a visit right now — is a second appointment needed?"
      },
      "submitWalkIn": "Book and add to queue",
      "walkInBooked": "Patient added to today’s queue.",
      "mode": "How to pick the time",
      "day": "Day",
      "visitType": "Visit type",
      "moreOptions": "More options (visit type, length, note)",
      "noneThisDay": "You have no free slot on this day.",
      "nextIs": "Your next free slot:",
      "noneIn30Days": "No free slot was found in the next 30 days either.",
      "slotAt": "{{date}}, {{time}}",
      "errors": {
        "clinic": "Choose a clinic.",
        "patient": "Choose a patient.",
        "name": "Enter the patient’s name.",
        "phone": "This mobile number is not valid.",
        "nationalId": "This national ID is not valid.",
        "when": "Enter the date and time.",
        "past": "This time has already passed.",
        "noSlot": "No free slot on this day; pick another day or enter the time yourself.",
        "phoneShared": "This number has other records; choose one or press “New patient on this number”."
      },
      "searchPickClinic": "Choose a clinic first to search its patients.",
      "phoneCandidates": {
        "title": "Records already on this number: {{count}}",
        "hint": "Is the person in front of you one of these? Choose them. If it is someone else on the same number (a family member, say), press “New patient on this number”.",
        "choose": "Choose",
        "sharedNote": "A new patient will be registered on a number that already has other records.",
        "showAgain": "Show records",
        "inClinic": "In this clinic’s list",
        "conflictOnSubmit": "This number has just been registered on another record; check the list.",
        "lookupFailed": "Could not check the records on this number. Please try again.",
        "checking": "Checking this number's records…",
        "checkFailed": "Could not check this number's records; they are checked again when you book."
      }
    },
    "phones": {
      "more": "More numbers: {{count}}",
      "otherLine": "{{relation}}: {{phone}}"
    },
    "withdraw": {
      "action": "Withdraw request",
      "title": "Withdraw appointment request",
      "message": "Withdraw the appointment request for {{name}}? It will be removed from the clinic’s list.",
      "confirm": "Withdraw request",
      "keep": "Cancel",
      "failed": "Could not withdraw the request."
    },
    "reschedule": {
      "current": "Current time: {{when}}",
      "newTime": "New time",
      "hint": "The appointment is moved, not cancelled and booked again, so its invoice and payment stay as they are.",
      "moved": "The appointment was moved to {{when}}."
    },
    "edit": {
      "untimedCurrent": "Out of turn — no time yet",
      "setTimeHint": "Set the time of this appointment; no message is sent to the patient.",
      "action": "Edit appointment",
      "title": "Edit appointment",
      "submit": "Save changes",
      "type": "Visit type",
      "inPerson": "In person",
      "online": "Online",
      "typeHint": "Only the visit type changes; the visit’s price stays as booked.",
      "typeLocked": {
        "over": "This visit is finished; its type can no longer change.",
        "notConfigured": "Online visits are not enabled on this system."
      },
      "timeLocked": {
        "status": "Only an appointment still waiting for its patient can be moved; this patient has arrived or the visit has started.",
        "grant": "At this clinic your appointments are confirmed by the front desk; leave moving this one to the clinic’s front desk.",
        "untimed": "This is a walk-in appointment with no fixed time, so there is no time to change."
      },
      "note": "Appointment note"
    },
    "rowOps": {
      "more": "More actions for {{name}}",
      "next": "Make next",
      "backToRoom": "Back to the room",
      "note": "Appointment note",
      "nextAppt": "Next appointment",
      "noShow": "No-show",
      "cancel": "Cancel appointment",
      "cancelled": "{{name}}’s appointment was cancelled.",
      "cancelTitle": "Cancel appointment",
      "cancelMessage": "{{name}}’s appointment at {{time}} will be cancelled. This cannot be undone.",
      "cancelConfirm": "Yes, cancel it",
      "noShowTitle": "Record a no-show",
      "noShowMessage": "{{name}}’s appointment at {{time}} will be recorded as a no-show.",
      "noShowConfirm": "Record no-show",
      "noteTitle": "Appointment note",
      "noteLabel": "Note for {{name}}’s appointment",
      "noteHint": "The clinic’s front desk sees this note too. Leave it empty to remove it.",
      "noteSave": "Save note",
      "errors": {
        "hasPayment": "A payment has been taken for this appointment; cancelling it is the front desk’s job.",
        "needsGrant": "At this clinic, cancellations and no-shows are handled by the front desk.",
        "paymentCheck": "The payment status of this appointment could not be checked; please try again.",
        "readOnly": "This clinic’s subscription has ended and its panel is read-only; this change has to wait until it is renewed.",
        "gone": "This appointment no longer exists; the list has been refreshed.",
        "next": "Could not make this patient next.",
        "cancel": "Could not cancel the appointment.",
        "noShow": "Could not record the no-show.",
        "note": "Could not save the note."
      }
    }
  },
  "nav": {
    "mobile": {
      "more": "More",
      "moreTitle": "More",
      "account": "Account",
      "sections": "Sections",
      "balance": "{{coin}} balance"
    }
  }
}
